import { transactionService } from '../services'

export default ( filters) => {
	return new Promise(resolve => {
		transactionService.getResumeAlertsByUserAssign( filters)
			.then(response => resolve({ success: true, data: response.data }))
	})
}
